import type { PermissionSelector } from "@/hooks/usePermission";

export const canListAnySurvey: PermissionSelector = (x) => x.surveys.canListAll || x.surveys.canManage;

export const canManageSurvey: PermissionSelector = (x) => x.surveys.canManage;
